<template>
  <div class="w-full justify-center items-center">
    <div class="max-w-826px mx-auto">
      <div class="flex flex-col">
        <div class="relative">
          <div>
            <div class="bg-gray-80 flex flex-col py-5 md:py-2 lg:min-w-826">
              <div class="flex flex-wrap md:divide-x-2 gap-y-5 divide-black h-full justify-center mx-auto max-w-4xl">
                <div class="px-2 flex justify-center" v-for="(brand, index) in brands">
                  <BrandCheckbox :label="brand.title" :key="brand.id" :field-id="'brand-'+brand.id"
                                 :image="brand.listingLogo" @input="() => handleBrandClicked(brand)"
                                 :checked="enabledBrandIds.includes(brand.id)"/>
                </div>
                <div class="px-2 flex justify-center">
                  <FilterDropdown label="Building Types" @all-clicked="clickedAllBuildings" :checked-items="enabledBuildingTypes" :options="buildingTypes"
                                  @item-clicked="toggleBuildingType"/>
                </div>
                <div class="px-2 flex justify-center">
                  <FilterDropdown label="Products" @all-clicked="clickedAllProducts" :checked-items="enabledProducts" :options="products"
                                  @item-clicked="toggleProduct"/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="w-full h-full">
            <GMapMap
                :center="center"
                :zoom="5"
                ref="mapRef"
                style="height: 600px"
                :disableDefaultUI="true"
            >
              <GMapMarker
                  :key="marker.id"
                  v-for="marker in markers"
                  @click="handleMarkerClicked(marker)"
                  :position="marker.projectLocation"
              />
            </GMapMap>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import BrandCheckbox from "../components/ProjectMap/BrandCheckbox.vue";
import FilterDropdown from "../components/ProjectMap/FilterDropdown.vue";
const sprigContainer = document.querySelector('#project-map-details')
export default {
  mounted() {
    this.$refs.mapRef.$mapPromise.then((mapObject) => {
      this.mapObject = mapObject
    });
  },
  data() {
    const allBrands = window.mapData.brands
    const allBrandIds = allBrands.map((b) => b.id)

    const allBuildingTypes = window.mapData.buildingTypes
    const allBuildingTypeIds = allBuildingTypes.map((b) => b.id)

    const allProducts = window.mapData.products
    const allProductIds = allProducts.map((b) => b.id)
    return {
      brands: allBrands,
      buildingTypes: allBuildingTypes,
      products: allProducts,

      mapObject: null,

      center: {lat: 47.116386, lng: -101.299591},


      enabledBrandIds: allBrandIds,
      enabledBuildingTypes: allBuildingTypeIds,
      enabledProducts: allProductIds
    }
  },
  computed: {
    brandProductMappings() {
      const mappings = {};
      
      // Initialize mappings for each brand
      this.brands.forEach(brand => {
        mappings[brand.id] = [];
      });
      
      // Map products to brands based on name patterns
      this.products.forEach(product => {
        if (product.title.includes('ACFoam') || product.title.includes('AC Foam')) {
          // Find ACFoam brand and add this product
          const acFoamBrand = this.brands.find(b => 
            b.title.includes('ACFoam') || 
            b.title.includes('AC Foam') ||
            b.title.toLowerCase().includes('acfoam')
          );
          if (acFoamBrand) {
            mappings[acFoamBrand.id].push(product.id);
          }
        }
        
        if (product.title.includes('EnergyShield') || product.title.includes('Energy Shield')) {
          // Find EnergyShield brand and add this product
          const energyShieldBrand = this.brands.find(b => 
            b.title.includes('EnergyShield') || 
            b.title.includes('Energy Shield') ||
            b.title.toLowerCase().includes('energyshield')
          );
          if (energyShieldBrand) {
            mappings[energyShieldBrand.id].push(product.id);
          }
        }
      });
      
      return mappings;
    },
    
    markers: function () {
      let locations = window.mapData.locations;
      if (this.enabledBrandIds.length > 0 && this.enabledBrandIds.length < this.brands.length) {
        locations = locations.filter((l) => {
          const intersection = l.projectFeaturedBrands.filter(value => this.enabledBrandIds.includes(value))
          return intersection.length > 0;
        })
      }

      if (this.enabledBuildingTypes.length > 0 && this.enabledBuildingTypes.length < this.buildingTypes.length) {
        locations = locations.filter((l) => {
          const intersection = l.projectBuildingTypes.filter(value => this.enabledBuildingTypes.includes(value))
          return intersection.length > 0;
        })
      }
      if (this.enabledProducts.length === 0) {
        // No products selected - show no locations
        locations = [];
      } else if (this.enabledProducts.length < this.products.length) {
        // Some (but not all) products selected - filter by selected products
        locations = locations.filter((l) => {
          const intersection = l.featuredProducts.filter(value => this.enabledProducts.includes(value))
          return intersection.length > 0;
        })
      }
      // If all products are selected (enabledProducts.length === this.products.length), show all locations (no filtering)
      return locations;
    }
  },
  watch: {
    markers: function (markers) {
      this.fitToMarkers(markers);
    }
  },
  methods: {
    fitToMarkers: function(markers) {
      if (!this.mapObject) {
        return;
      }
      var bounds = new google.maps.LatLngBounds();
      var length = markers.length;
      for (var i = 0; i < length; i++) {
        bounds.extend(new google.maps.LatLng(markers[i].projectLocation.lat, markers[i].projectLocation.lng));
        this.mapObject.fitBounds(bounds);
      }
    },
    clickedAllBuildings: function() {
      const allBuildingTypeIds = this.buildingTypes.map((b) => b.id);
      const allCurrentlySelected = this.enabledBuildingTypes.length === allBuildingTypeIds.length;
      
      if (allCurrentlySelected) {
        // All building types are currently selected - uncheck all
        this.enabledBuildingTypes = [];
      } else {
        // Not all building types are selected - select all
        this.enabledBuildingTypes = allBuildingTypeIds;
      }
    },
    clickedAllProducts: function () {
      const allProductIds = this.products.map((p) => p.id);
      const allCurrentlySelected = this.enabledProducts.length === allProductIds.length;
      
      if (allCurrentlySelected) {
        // All products are currently selected - uncheck all
        this.enabledProducts = [];
        // Also uncheck all brands
        this.enabledBrandIds = [];
      } else {
        // Not all products are selected - select all
        this.enabledProducts = allProductIds;
        // Also check all brands
        this.enabledBrandIds = this.brands.map((b) => b.id);
      }
    },
      toggleBuildingType: function (buildingType) {
          const index = this.enabledBuildingTypes.indexOf(buildingType.id);
          if (index > -1) {
              this.enabledBuildingTypes.splice(index, 1);
          } else {
              this.enabledBuildingTypes.push(buildingType.id);
          }
      },


    handleBrandClicked: function (brand) {
      const wasEnabled = this.enabledBrandIds.includes(brand.id);
      
      // Toggle brand
      if (wasEnabled) {
        this.enabledBrandIds = this.enabledBrandIds.filter(v => v !== brand.id);
      } else {
        this.enabledBrandIds.push(brand.id);
      }
      
      // Get products for this brand
      const brandProducts = this.brandProductMappings[brand.id] || [];
      
      if (wasEnabled) {
        // Brand was unchecked - remove its products (unless they belong to other enabled brands)
        brandProducts.forEach(productId => {
          const belongsToOtherEnabledBrands = this.enabledBrandIds.some(enabledBrandId => 
            this.brandProductMappings[enabledBrandId]?.includes(productId)
          );
          
          if (!belongsToOtherEnabledBrands) {
            this.enabledProducts = this.enabledProducts.filter(id => id !== productId);
          }
        });
      } else {
        // Brand was checked - add its products
        brandProducts.forEach(productId => {
          if (!this.enabledProducts.includes(productId)) {
            this.enabledProducts.push(productId);
          }
        });
      }
    },
      toggleProduct: function (product) {
          const productId = product.id;
          const index = this.enabledProducts.indexOf(productId);
          const wasEnabled = index > -1;
          
          if (wasEnabled) {
              this.enabledProducts.splice(index, 1);
          } else {
              this.enabledProducts.push(productId);
          }
          
          // Find which brand this product belongs to and update brand checkbox
          for (const [brandId, productIds] of Object.entries(this.brandProductMappings)) {
              if (productIds.includes(productId)) {
                  const brandIdInt = parseInt(brandId);
                  
                  if (wasEnabled) {
                      // Product was unchecked - uncheck its brand
                      this.enabledBrandIds = this.enabledBrandIds.filter(id => id !== brandIdInt);
                  } else {
                      // Product was checked - only check brand if ALL brand products are now selected
                      const allBrandProductsSelected = productIds.every(pid => this.enabledProducts.includes(pid));
                      if (allBrandProductsSelected && !this.enabledBrandIds.includes(brandIdInt)) {
                          this.enabledBrandIds.push(brandIdInt);
                      }
                  }
              }
          }
      },


    handleMarkerClicked: function (marker) {
      const projectIdInput = document.querySelector('#project-id');
      projectIdInput.value = marker.id;
      htmx.trigger('#project-map-details', 'refresh');
    }

  },
  components: {
    FilterDropdown,
    BrandCheckbox
  }
};
</script>
